export default __webpack_public_path__ + "static/media/edit.ec2741ae.svg";